import { render, staticRenderFns } from "./progress-update.vue?vue&type=template&id=2c74bdb2&scoped=true"
import script from "./progress-update.vue?vue&type=script&lang=js"
export * from "./progress-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c74bdb2",
  null
  
)

export default component.exports